import { type ActivityKind, visibleActivityKinds } from "@visioni/a3s-activity-recorder/types";

// TODO: remove when alarm activations are tracked
const UNTRACKED_ACTIVITY_KINDS: readonly ActivityKind[] = ["alarm_activated"];

/**
 * The activity kinds a caller may pick in the activity-type filter.
 *
 * Derived from {@link visibleActivityKinds} so support-only kinds never appear
 * as a filter for rows the caller can never be returned — the list query
 * enforces the same rule server-side.
 */
export function filterableActivityKinds(isSupportUser: boolean): ActivityKind[] {
  return visibleActivityKinds(isSupportUser).filter((kind) => !UNTRACKED_ACTIVITY_KINDS.includes(kind));
}
